// views/OldMirascanView.tsx
import React from "react";
import OldQrcodeTemplate from "@/components/templates/verifies/OldQrcodeTemplate";

const OldMirascanView: React.FC = () => {
  return <OldQrcodeTemplate oldQrcode="mirascan" />;
};

export default OldMirascanView;
